/*
 * ShiftCancellationButton Messages
 *
 * This contains all the text for the ShiftCancellationButton component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelShift: {
    id: 'app.components.ShiftCancellationButton.cancelShift',
    defaultMessage: 'Cancel shift',
  },
  confirmCancellationTitle: {
    id: 'app.components.ShiftCancellationButton.confirmCancellationTitle',
    defaultMessage: 'Cancel shift',
  },
  confirmCancellationDescription: {
    id: 'app.components.ShiftCancellationButton.confirmCancellationDescription',
    defaultMessage:
      'Cancelling the shift will notify all assigned publishers about the shift cancellation and cannot be undone.',
  },
  cancellationLabel: {
    id: 'app.components.ShiftCancellationButton.cancellationLabel',
    defaultMessage: 'Reason',
  },
  confirmCancellation: {
    id: 'app.components.ShiftCancellationButton.confirmCancellation',
    defaultMessage: 'Cancel shift',
  },
  cancelCancellation: {
    id: 'app.components.ShiftCancellationButton.cancelCancellation',
    defaultMessage: "Don't cancel shift",
  },
  cancellationSuccess: {
    id: 'app.components.ShiftCancellationButton.cancellationSuccess',
    defaultMessage: 'Shift cancelled successfully.',
  },
  cancellationFailure: {
    id: 'app.components.ShiftCancellationButton.cancellationFailure',
    defaultMessage: 'Error. Cancelling the shift failed.',
  },
});
